import React, { useState, useCallback, useEffect, useContext } from 'react';
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  HStack,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Text,
  VStack,
  useToast,
  Icon,
  Circle,
  Divider,
  Badge,
} from '@chakra-ui/react';
import { CheckCircleIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import { IoMdTime } from 'react-icons/io';
import { MdPayment, MdAccountBalanceWallet, MdReceipt, MdCheck } from 'react-icons/md';
import successImage from '../../../assets/lab_search/payment/3.png';
import { getUser } from '../../../cookie/user';
import { createOrder } from '../../../api/order';

import { Link } from 'react-router-dom';
import useCartStore from '../../../store/cartStore';
import { CartContext } from '../../../context/cart';
import axios from 'axios';
import useLabsStore from '../../../store/labsStore';

export const PaymentSection = () => {
  // const navigate = useNavigate();
  const { setCart, totalOrderPrice } = useCartStore();
  const { labData } = useLabsStore();
    const { 
      setCartPlans, 
      setActiveStep, 
      orderDetail, 
      cartData, 
      setIsPaymentMethodConfirmed, 
      triggerOrderPlacement, 
      setTriggerOrderPlacement, 
      setOrderSuccess, 
      paymentStatus, 
      setPaymentStatus, 
      sessionOrderId, 
      setSessionOrderId,
      bookingStatus,
      setBookingStatus
    } = useContext(CartContext);

  const user = getUser();
  // const [paymentStatus, setPaymentStatus] = useState('pending'); // moved to context
  const [paymentMode, setPaymentMode] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [, setLoading] = useState(false);
  const [packagesData, setPackagesData] = useState([]);
  const [testData, setTestData] = useState([]);
  const [razorpayOrder, setRazorpayOrder] = useState('');
  const [checkoutSuccess, setCheckoutSuccess] = useState(false);

  const toast = useToast();

  useEffect(() => {
    let filteredPackages = cartData?.filter(plan => !plan.tag);
    let filteredTests = cartData?.filter(plan => plan.tag);
    setPackagesData(filteredPackages || []);
    setTestData(filteredTests || []);
  }, [cartData]);

  const verificationHandler = useCallback(async response => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER}/paymentverification`,
        { response }
      );
      setRazorpayOrder(res?.data?.razorpayOrder);
      setCheckoutSuccess(true);
    } catch (error) {
      console.error('error in the verification request');
    }
  }, []);

  const razorpayCheckoutHandler = useCallback(async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER}/checkoutOrder`,
        { totalOrderPrice }
      );

      const orderId = res.data.razorpayOrder.id;
      const options = {
        key: process.env.REACT_APP_RAZORPAY_API_KEY,
        amount: res.data.razorpayOrder.amount,
        currency: 'INR',
        name: user?.firstName + ' ' + user?.lastName,
        description: 'Transaction for DLab',
        image: user?.fileUrl,
        order_id: orderId,
        handler: async response => verificationHandler(response),
        prefill: {
          name: user?.firstName + ' ' + user?.lastName,
          email: user?.email ? user?.email : 'xyz@gmail.com',
          contact: user?.phone,
        },
        theme: {
          color: '#0c727e',
        },
      };

      const razor = new window.Razorpay(options);
      razor.open();
    } catch (error) {
      console.error('error while creating checkout', error);
    }
  }, [totalOrderPrice, user, verificationHandler]);

  const orderHandler = useCallback(async (items, itemType, customOrderId) => {
    if (!items || items.length === 0) return true;

    for (const item of items) {
      if (!item?.patients) continue;
      for (const patient of item.patients) {
        if (!patient?._id) {
          console.warn(`Web: Skipping order for ${item.name} because patientId is missing`);
          continue;
        }
        const orderData = {
          user: user?._id || user?.id,
          patientId: patient?._id,
          lab: labData?._id,
          test: itemType === 'test' ? item : {},
          packages: itemType === 'packages' ? item : {},
          name: item?.name,
          sampleMode: orderDetail?.sampleMode,
          appointmentDate: orderDetail?.appointmentDate,
          appointmentTime: orderDetail?.appointmentTime,
          patientDetails: patient,
          consumerDetails: {
            user: { ...user, _id: user?._id || user?.id },
            phone: orderDetail?.phone,
            email: orderDetail?.email,
            mainAddress: orderDetail?.mainAddress,
            address: orderDetail?.address,
          },
          paymentDetails: {
            orderPaymentStatus: checkoutSuccess ? 'success' : 'no online payment',
            price: parseInt(item.price),
            mode: paymentMode,
            razorpayOrder: checkoutSuccess ? razorpayOrder : 'not a razorpay order',
          },
          orderId: customOrderId,
        };

        console.log(`Web: Creating order for ${item.name}, Patient: ${patient.name || 'Unknown'} (ID: ${patient._id}), OrderId: ${customOrderId}`);

        try {
          await createOrder(orderData);
        } catch (error) {
          console.error(`Error creating order for ${item.name}:`, error?.response?.data || error.message);
          const errorMsg = error?.response?.data?.message || `Failed to create order for ${item.name}`;
          toast({
            title: 'Booking Error',
            description: errorMsg,
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
          return false;
        }
      }
    }
    return true;
  }, [user, labData, orderDetail, checkoutSuccess, razorpayOrder, paymentMode, toast]);

  const confirmSelection = () => {
    setPaymentStatus('confirming');
    setIsPaymentMethodConfirmed(true);
    setIsModalOpen(false);
  };

  const placeFinalOrder = useCallback(async () => {
    if (bookingStatus === 'booking' || bookingStatus === 'success') {
      console.log('Web: Booking already in progress or completed. Skipping.');
      return;
    }
    
    setBookingStatus('booking');
    setLoading(true);
    try {
      if (paymentMode === 'razorpay') {
        razorpayCheckoutHandler();
      } else {
        // Use persistent sessionOrderId or generate a new one if it doesn't exist
        let currentOrderId = sessionOrderId;
        if (!currentOrderId) {
          currentOrderId = 'DL' + Math.floor(100000 + Math.random() * 900000);
          setSessionOrderId(currentOrderId);
        }

        const testSuccess = await orderHandler(testData, 'test', currentOrderId);
        if (!testSuccess) {
          setBookingStatus('error');
          setLoading(false);
          setTriggerOrderPlacement(false);
          return;
        }
        
        const packageSuccess = await orderHandler(packagesData, 'packages', currentOrderId);
        if (!packageSuccess) {
          setBookingStatus('error');
          setLoading(false);
          setTriggerOrderPlacement(false);
          return;
        }

        setPaymentStatus('success');
        setCart([]);
        setCartPlans([]);
        setIsPaymentMethodConfirmed(false);
        setTriggerOrderPlacement(false);
        setOrderSuccess(true);
        setBookingStatus('success');
      }
    } catch (error) {
      console.error('Error creating order:', error);
      setBookingStatus('error');
      toast({
        title: 'Error in order process',
        status: 'error',
        duration: 5000,
      });
    } finally {
      setLoading(false);
    }
  }, [paymentMode, testData, packagesData, orderHandler, razorpayCheckoutHandler, setCart, setCartPlans, setIsPaymentMethodConfirmed, setTriggerOrderPlacement, setOrderSuccess, setPaymentStatus, toast, bookingStatus, setBookingStatus, sessionOrderId, setSessionOrderId]);

  useEffect(() => {
    if (triggerOrderPlacement) {
      placeFinalOrder();
    }
  }, [triggerOrderPlacement, placeFinalOrder]);

  useEffect(() => {
    const handleRazorpaySuccess = async () => {
      if (checkoutSuccess) {
        let currentOrderId = sessionOrderId;
        if (!currentOrderId) {
          currentOrderId = 'DL' + Math.floor(100000 + Math.random() * 900000);
          setSessionOrderId(currentOrderId);
        }
        const testSuccess = await orderHandler(testData, 'test', currentOrderId);
        if (testSuccess) {
          await orderHandler(packagesData, 'packages', currentOrderId);
        }
        setPaymentStatus('success');
        setCart([]);
        setCartPlans([]);
        setOrderSuccess(true);
      }
    };
    handleRazorpaySuccess();
  }, [checkoutSuccess, testData, packagesData, orderHandler, setCart, setCartPlans, setOrderSuccess, setPaymentStatus, sessionOrderId, setSessionOrderId]);

  const displayedOrderId = sessionOrderId || 'Generating...';

  const handleModalClose = () => setIsModalOpen(false);
  const handlePaymentModeChange = value => setPaymentMode(value);

  // Initial State: Show "Pending" Status Card
  if (paymentStatus === 'pending') {
    return (
      <VStack
        sx={{
          spacing: '10',
          border: '1px solid rgba(0, 0, 0, 0.2)',
          borderRadius: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '0px',
          flex: '7',
          width: '100%',
          bg: 'white',
          overflow: 'hidden'
        }}
      >
        <Heading
          width={'100%'}
          textAlign={'center'}
          color={'#0C727E'}
          borderBottom="1px solid rgba(0, 0, 0, 0.1)"
          padding={'5'}
          fontSize="24px"
        >
          Payment Status
        </Heading>
        <Box
          width="100%"
          display={'flex'}
          flexDir={['column', 'column', 'row', 'row']}
          justifyContent={'center'}
          alignItems={'center'}
          p={'10'}
          gap="10"
        >
          <Image src={successImage} maxW="300px" />
          <VStack spacing={6} align="start" flex={1}>
            <Badge colorScheme="red" p={2} borderRadius="md" px={4}>
              Your payment is pending
            </Badge>
            <Text fontSize="lg" fontWeight="500" color="black">
              Please complete the payment process to proceed with your order
            </Text>
            <Button
              colorScheme="teal"
              size="lg"
              h="60px"
              px={10}
              borderRadius="full"
              fontSize="lg"
              boxShadow="xl"
              onClick={() => setIsModalOpen(true)}
              _hover={{ transform: 'translateY(-2px)' }}
            >
              Complete Payment
            </Button>
          </VStack>
        </Box>

        <PaymentModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          mode={paymentMode}
          onModeChange={handlePaymentModeChange}
          price={totalOrderPrice}
          onConfirm={confirmSelection}
        />
      </VStack>
    );
  }

  // Middle State: Confirming "Pay at Lab" Choice
  if (paymentStatus === 'confirming') {
    return (
      <VStack
        spacing={8}
        p={8}
        border="1px solid rgba(0, 0, 0, 0.1)"
        borderRadius="24px"
        bg="white"
        flex="7"
        w="100%"
        boxShadow="sm"
      >
        <VStack spacing={2} textAlign="center">
          <Heading color="black" size="lg">Confirm Booking</Heading>
          <Text color="black">You have selected <b>Pay At Lab</b> as your payment method</Text>
        </VStack>

        <Box w="100%" bg="gray.50" p={6} borderRadius="2xl" border="1px solid" borderColor="gray.100">
          <VStack spacing={4} align="stretch">
            <Flex justify="space-between" align="center">
              <HStack spacing={3}>
                <Icon as={MdPayment} color="teal.600" />
                <Text fontWeight="600" color="black">Selected Method</Text>
              </HStack>
              <Badge colorScheme="orange" fontSize="sm">Pay At Lab</Badge>
            </Flex>
            <Divider />
            <Flex justify="space-between" align="center">
              <Text color="black" fontWeight="500">Total Amount</Text>
              <Text fontWeight="bold" fontSize="xl" color="black">₹{totalOrderPrice}/-</Text>
            </Flex>
          </VStack>
        </Box>

        <HStack w="100%" spacing={4}>
          <Button variant="ghost" flex={1} size="lg" h="56px" onClick={() => setIsModalOpen(true)}>Change Method</Button>
        </HStack>

        <PaymentModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          mode={paymentMode}
          onModeChange={handlePaymentModeChange}
          price={totalOrderPrice}
          onConfirm={confirmSelection}
        />
      </VStack>
    );
  }

  // Final Success State (Image 2 style)
  if (paymentStatus === 'success') {
    return (
      <VStack
        spacing={0}
        bg="#F8FAFC"
        borderRadius="32px"
        overflow="hidden"
        w="100%"
        flex="7"
        position="relative"
      >
        {/* Header with Stepper Progress */}
        <Box w="100%" bg="white" pt={8} pb={6} px={10} shadow="sm">
          <VStack spacing={6}>
            <HStack w="100%" justify="space-between" align="center" position="relative">
              {[1, 2, 3, 4, 5].map((s) => (
                <Circle key={s} size="24px" bg="teal.600" color="white" zIndex={2}>
                  <Icon as={MdCheck} size="14px" />
                </Circle>
              ))}
              <Box position="absolute" top="11px" left="0" right="0" h="2px" bg="teal.600" zIndex={1} />
            </HStack>
            <Heading size="md" color="teal.800" fontWeight="800" letterSpacing="1px">ORDER CONFIRMED</Heading>
          </VStack>
        </Box>

        <VStack spacing={10} p={10} bg="white" w="100%" h="100%" align="center">
          <VStack spacing={6} align="center">
            <Circle size="140px" bg="gray.50" border="1px solid" borderColor="gray.100" shadow="inner">
              <Box bg="white" p={6} borderRadius="full" shadow="xl">
                <Icon as={CheckCircleIcon} boxSize="60px" color="teal.500" />
              </Box>
            </Circle>
            <VStack spacing={2}>
              <Heading size="xl" color="gray.800">Thank You!</Heading>
              <Text fontSize="lg" color="gray.500">Your order has been placed successfully.</Text>
            </VStack>
          </VStack>

          <Box bg="white" p={8} borderRadius="32px" border="1px solid" borderColor="gray.100" shadow="lg" w="100%" maxW="400px" textAlign="center">
            <VStack spacing={1}>
              <Text fontSize="sm" fontWeight="700" color="gray.400" letterSpacing="1px">ORDER ID</Text>
              <Heading size="lg" color="gray.800">{displayedOrderId}</Heading>
            </VStack>
          </Box>

          <Text textAlign="center" color="gray.500" fontSize="md" px={8} lineHeight="tall">
            A confirmation message has been sent to your registered phone number and email address.
          </Text>

          <VStack w="100%" spacing={6}>
            <Button
              as={Link}
              to="/profile/orders"
              onClick={() => {
                setOrderSuccess(false);
                setPaymentStatus('pending');
                setActiveStep(1);
              }}
              leftIcon={<ExternalLinkIcon />}
              colorScheme="teal"
              size="lg"
              w="100%"
              maxW="400px"
              h="70px"
              borderRadius="20px"
              fontSize="xl"
              fontWeight="bold"
              boxShadow="0 10px 20px rgba(0, 128, 128, 0.2)"
              _hover={{ transform: 'translateY(-3px)', shadow: '2xl' }}
            >
              Track Your Order
            </Button>

            <Box bg="gray.50" p={5} borderRadius="20px" w="100%" maxW="440px" shadow="sm">
              <HStack spacing={4} color="gray.600">
                <Icon as={IoMdTime} boxSize="20px" />
                <Text fontSize="sm" fontWeight="500">Our phlebotomist will arrive as per your selected slot.</Text>
              </HStack>
            </Box>
          </VStack>
        </VStack>
      </VStack>
    );
  }

  return null;
};

// Extracted Modal for Clarity
const PaymentModal = ({ isOpen, onClose, mode, onModeChange, price, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={['full', 'xl']} isCentered>
      <ModalOverlay backdropFilter="blur(8px)" />
      <ModalContent borderRadius="2xl" p={2} boxShadow="2xl">
        <ModalHeader pb={0}>
          <VStack align="start" spacing={1}>
            <Text fontSize="2xl" fontWeight="bold" color="teal.800">Payment Options</Text>
            <Text fontSize="sm" fontWeight="normal" color="gray.500">Choose how you'd like to pay</Text>
          </VStack>
        </ModalHeader>
        <ModalCloseButton top={6} right={6} />

        <ModalBody py={6}>
          <VStack spacing={6} w="100%">
            <Box w="100%" p={5} bg="teal.50" borderRadius="2xl" border="1px dashed" borderColor="teal.200">
              <Flex justify="space-between" align="center">
                <Text fontWeight="600" color="teal.700">Total Amount Payable</Text>
                <Text fontSize="2xl" fontWeight="800" color="teal.600">₹{price}/-</Text>
              </Flex>
            </Box>

            <RadioGroup onChange={onModeChange} value={mode} w="100%">
              <VStack spacing={4} w="100%">
                {/* Pay At Lab Option */}
                <Box
                  as="label"
                  w="100%"
                  cursor="pointer"
                  border="2px solid"
                  borderColor={mode === 'labpay' ? 'teal.500' : 'gray.100'}
                  borderRadius="2xl"
                  p={5}
                  bg={mode === 'labpay' ? 'teal.50' : 'white'}
                >
                  <Radio value="labpay" display="none" />
                  <HStack spacing={4}>
                    <Center w="50px" h="50px" bg="orange.100" borderRadius="full">
                      <MdReceipt color="#DD6B20" size="24" />
                    </Center>
                    <VStack align="start" spacing={0} flex={1}>
                      <Text fontWeight="bold" color="teal.900" fontSize="lg">Pay At Lab</Text>
                      <Text fontSize="sm" color="gray.600">Pay using Cash/Card upon visit</Text>
                    </VStack>
                    {mode === 'labpay' && <Circle size="24px" bg="teal.500"><MdCheck color="white" /></Circle>}
                  </HStack>
                </Box>

                {/* Pay Online Option */}
                <Box
                  w="100%"
                  position="relative"
                  border="2px solid"
                  borderColor="gray.100"
                  borderRadius="2xl"
                  p={5}
                  bg="gray.50"
                  opacity={0.8}
                >
                  <Badge position="absolute" top={-2} right={4} colorScheme="purple" borderRadius="full" px={3} py={1}>
                    Coming Soon
                  </Badge>
                  <HStack spacing={4}>
                    <Center w="50px" h="50px" bg="blue.100" borderRadius="full">
                      <MdAccountBalanceWallet color="#2B6CB0" size="24" />
                    </Center>
                    <VStack align="start" spacing={0} flex={1}>
                      <Text fontWeight="bold" color="gray.500" fontSize="lg">Pay Now (Online)</Text>
                      <Text fontSize="sm" color="gray.400">Secure payment via UPI or Cards</Text>
                    </VStack>
                  </HStack>
                </Box>
              </VStack>
            </RadioGroup>
          </VStack>
        </ModalBody>

        <ModalFooter pb={6}>
          <Button variant="ghost" mr={3} onClick={onClose} size="lg">Cancel</Button>
          <Button
            colorScheme="teal"
            size="lg"
            h="60px"
            w="full"
            borderRadius="full"
            isDisabled={mode !== 'labpay'}
            onClick={onConfirm}
          >
            Continue to Confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
